import { removeEmptySpacesFromCurrency } from 'shared/utils/currency'


export enum CartValidationErrors {
  MIN_ORDER_VALUE_MISSING = 'Minimalna wartość koszyka'
}

export const getSummaryButtonLabelByPage = (
  pageType: string,
  paymentValue: string
) => {
  switch (pageType) {
    case 'payment':
      return `Płacę i zamawiam ${removeEmptySpacesFromCurrency(paymentValue)}`
    case 'cart':
      return `Przejdź do dostawy ${removeEmptySpacesFromCurrency(paymentValue)}`
    case 'delivery':
      return `Przejdź do płatności ${removeEmptySpacesFromCurrency(paymentValue)}`
    default:
      return `Przejdź dalej ${removeEmptySpacesFromCurrency(paymentValue)}`
  }
}

export const getSummaryButtonId = (
  pageType: string,
  isCartDrawer: boolean
) => {
  if (isCartDrawer) {
    return 'to_cart_button'
  }

  switch (pageType) {
    case 'payment':
      return 'cart_summary_proceed_payment_button'
    case 'delivery':
      return 'cart_summary_proceed_payment_button'
    default:
      return 'cart_summary_proceed_button'
  }
}

export const generateSummaryButtonTestTag = (
  isMobile: boolean,
  pageType: string,
  isCartDrawer: boolean
) => {
  const deviceType = isMobile ? 'mobile' : 'desktop'
  const placement = isCartDrawer ? 'drawer' : pageType

  return `${deviceType}-${placement}-checkout-button`
}

export const IS_PACKING_COST_ENABLED =
  process.env.NEXT_PUBLIC_PACKING_COST_ENABLED === 'true'
